<div class="popup">
    <div class="container-detalles panelDetailLocations" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}">

      <div *ngIf="!mobileQuery.matches" class="arrow-container">
          <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
      </div>
      <div class="details-flex car-details-flex">
  
        <!-- Primera sección -->
        <div class="header_panel">
  
            <!-- Encabezado -->
            <div class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
              <ngx-skeleton-loader class="header-img" count="1" appearance="circle" [theme]="mobileQuery.matches ? { 'width': '7vw', 'height': '7vw', 'background-color': '#bdbdb9', 'margin': '0' } : { 'width': '70px', 'height': '70px', 'background-color': '#bdbdb9', 'margin': '0' }"></ngx-skeleton-loader>
            </div>
  
            <!-- VIN-->
            <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
                <label *ngIf="!mobileQuery.matches" class="header-text-label">Id</label>
                <label class="vin-title-container"> 

                  <div class="btnReturn" (click)="CancelButton()" matTooltip="Regresar">
                    <mat-icon>arrow_back_ios</mat-icon>
                  </div>

                  <div class="copy-to-clipboard">
                    <ngx-skeleton-loader count="1" appearance="circle" [theme]="{ 'background-color': '#bdbdb9' }"></ngx-skeleton-loader>
                  </div>

                  <div class="vin-title">
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                  </div>

                  <div class="tool-opener" >
                    <!-- <ngx-skeleton-loader count="1" appearance="circle" [theme]="{ 'background-color': '#bdbdb9' }"></ngx-skeleton-loader> -->
                  </div>
                </label>
                
                <label *ngIf="!mobileQuery.matches" class="header-text-label">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '50%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
                <label class="subtitlePanel"> 
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '50%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
        </div>
        <!-- seccion de tabs -->
        <div class="tab-group">
          <mat-tab-group>
            <mat-tab>
              <ng-template mat-tab-label >
                <label  matTooltip="Resumen del Activo" matTooltipPosition="above">

                </label>
              </ng-template>
              <ng-template matTabContent >
                  <div class="tab-content-wrapper" style="overflow: hidden;">
                    
                    <!-- primera sección -->
                    <div class="data-section-container">
                      <div class="text-header">
                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '50%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                      </div>
                      <!-- datos generales de carros (para el shade se puede usar background-shade) -->
                        <div *ngFor="let skel of [1,2,3,4,5,6]" class="row-data" style="width: 100%;">
                          <div class="">
                            <label class="titlePanel">
                              <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                            </label>
                          </div>
                          <div class="">
                            <div class="general-data">
                              <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px'  }"></ngx-skeleton-loader>
                            </div>
                          </div>
                        </div>
                    </div>

                    <div class="data-section-container">
                      <div class="text-header">
                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '50%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                      </div>
                      <!-- datos generales de carros (para el shade se puede usar background-shade) -->
                        <div *ngFor="let skel of [1,2,3,4,5,6]" class="row-data" style="width: 100%;">
                          <div class="">
                            <label class="titlePanel">
                              <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                            </label>
                          </div>
                          <div class="">
                            <div class="general-data">
                              <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px'  }"></ngx-skeleton-loader>
                            </div>
                          </div>
                        </div>
                    </div>

                </div>
  
              </ng-template>
            </mat-tab>
            
          </mat-tab-group>
        </div>
      </div>  
  
    </div>
  </div>